import React from 'react';
import styled from 'styled-components';
import { media } from '../../global';

import { Callout } from './components';

const format = phone => {
  return phone.replace(/-|\s|\(|\)/g, '');
};

// Check if we're on the franchise site or newsroom
const isFranchiseSite = () => {
  if (typeof window !== 'undefined') {
    return window.location.hostname.includes('franchise') || 
           window.location.pathname.startsWith('/franchising') ||
           window.location.pathname.startsWith('/newsroom');
  }
  return false;
};

const Address = styled.address`
  flex: 1 1 auto;
  font-style: normal;
  line-height: 1.5;

  ${media.down.md`
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 50%;
    margin-top: 56px;
  `}
`;

const Heading = styled(Callout)`
  display: block;
  line-height: 1;
  margin-bottom: 9px;
`;

const EmailAnchor = styled.a.attrs(p => ({ href: `mailto:${p.children}` }))`
  color: inherit;
  text-decoration: underline;
`;

const PhoneAnchor = styled.a.attrs(p => ({
  href: `tel:${format(p.children)}`
}))`
  color: inherit;
  text-decoration: underline;
`;

export default () => {
  const phoneNumber = isFranchiseSite() ? '(281) 664-2687' : '(844) 725-2821';
  const email = isFranchiseSite() ? 'pam.cohnen@salata.com' : 'contact@salata.com';
  
  return (
    <Address>
      <Heading>Salata Home Office</Heading>
      16720 Park Row Dr
      <br />
      Houston, TX 77084
      <br />
      <br />
      Phone: <PhoneAnchor>{phoneNumber}</PhoneAnchor>
      <br />
      <EmailAnchor>{email}</EmailAnchor>
    </Address>
  );
};
